import { render, staticRenderFns } from "./UserOrdersView.vue?vue&type=template&id=02df554c&scoped=true&"
import script from "./UserOrdersView.vue?vue&type=script&lang=js&"
export * from "./UserOrdersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df554c",
  null
  
)

export default component.exports